import { render, staticRenderFns } from "./CPLegal.vue?vue&type=template&id=31e987a0&scoped=true&"
import script from "./CPLegal.vue?vue&type=script&lang=ts&"
export * from "./CPLegal.vue?vue&type=script&lang=ts&"
import style0 from "./CPLegal.vue?vue&type=style&index=0&id=31e987a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e987a0",
  null
  
)

export default component.exports